import { LOCALE_ID, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';
import { LanguageStubService } from '@uigy/testing/language.stub.service';
import { I18NextLoadResult, I18NextModule, I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

function testInit(i18next: ITranslationService) {
  return (): Promise<I18NextLoadResult> => i18next.init({lng: 'cimode'});
}

export function localeIdFactory(i18next: ITranslationService): string {
  return i18next.language;
}

@NgModule({
  imports: [I18NextModule.forRoot()],
  exports: [I18NextModule],
})
export class LanguageModule {
  static forRoot(): ModuleWithProviders<LanguageModule> {
    return {
      ngModule: LanguageModule,
      providers: [
        {
          provide: LOCALE_ID,
          deps: [I18NEXT_SERVICE],
          useFactory: localeIdFactory,
        },
        LanguageService
      ]
    };
  }

  static forChild(): ModuleWithProviders<I18NextModule> {
    return {
      ngModule: I18NextModule
    };
  }

  static forTest(): ModuleWithProviders<LanguageModule> {
    return {
      ngModule: LanguageModule,
      providers: [
        provideAppInitializer(() => {
        const initializerFn = (testInit)(inject(I18NEXT_SERVICE));
        return initializerFn();
      }),
        {
          provide: LOCALE_ID,
          deps: [I18NEXT_SERVICE],
          useValue: 'en',
        },
        {provide: LanguageService, useClass: LanguageStubService},
      ],
    };
  }
}
